// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import 'jquery';
import Vuetable from 'vuetable-2';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate/dist/vee-validate.full.esm';
import vueSmoothScroll from 'vue-smooth-scroll';
// import Es6Promise from 'es6-promise';
import store from './packages/vuex/store';
import eventBus from './packages/events/eventBus';
import App from './components/App';
import router from './router/routes';
import auth from './packages/auth/Auth';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/endcustomer.css';


Vue.use(auth);
Vue.use(eventBus);
Vue.use(store);
Vue.use(vueSmoothScroll);

// Es6Promise.polyfill();

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('verify_password', (value) => {
  const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');
  if (strongRegex.test(value)) {
    return true;
  }

  return 'Your password must contain at least: 1 uppercase letter, 1 lowercase letter and 1 number';
});
extend('search_term_length', (value) => {
  if (value.length >= 2) {
    return true;
  }

  return 'Keep typing... we need at least 2 characters to search';
});
extend('valid_postcode', (value) => {
  const postcodeRegex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})/;
  if (postcodeRegex.test(value)) {
    return true;
  }

  return 'Please type a valid postcode';
});


// TODO: Putting tooltip directive here feels wrong but couldn't
//   get it to work in component itself (need more learning).
Vue.directive('tooltip', (el, binding) => {
  document.getElementById(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover',
  });
});

// Minimal and library dependency-free vanilla JavaScript
// polyfill for datalist-functionality (for Safari and ie9)
// see https://github.com/mfranzke/datalist-polyfill
// require('datalist-polyfill');

Vue.config.productionTip = false;

window.Pusher = require('pusher-js');
window.phoneNumberFormatter = require('google-libphonenumber').PhoneNumberFormat;
window.phoneNumberUtilities = require('google-libphonenumber').PhoneNumberUtil.getInstance();

function checkAuthc() {
  return new Promise((resolve) => {
    // console.log('    Vue.auth.isAuthenticated()?');
    if (Vue.auth.isAuthenticated()) {
      store.commit('CLOAKED', true);
      // console.log('    Waiting to fetch the user object etc...');
      store.dispatch('authenticated').then(() => {
        // console.log('    Done - All should be OK now, including routing');
        // console.log('    Calling the resolve() function...');
        resolve();
      });
    } else {
      localStorage.removeItem('access_token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
      store.commit('AUTHENTICATED', false);
      store.commit('CLOAKED', false);
      // console.log('    Calling the resolve() function...');
      resolve();
    }
    // console.log('<<< checkAuthc()');
  });
}

checkAuthc();

// eslint-disable-next-line no-unused-vars
const z = new Vue({
  el: '#app',
  store,
  router,
  Vuetable,
  template: '<App/>',
  components: {
    App,
    'vuetable-pagination': Vuetable.VuetablePagination,
  },
  methods: {
    transform(data) {
      const transformed = {};

      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to,
      };

      transformed.mydata = [];

      for (let i = 0; i < data.length; i += 1) {
        transformed.mydata.push({
          id: data[i].id,
          company_name: data[i].companyoverview.company_name,
          email: data[i].email,
        });
      }

      return transformed;
    },
    
  },
});
